import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SarSvg } from "../../Assets/SAR.svg";

/**
 * SAR currency mark — use in place of AttachMoney / money icons.
 * Paths use currentColor so MUI `color`, `sx.color`, and `fontSize` behave like SvgIcon.
 */
export default function SarIcon(props) {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      component={SarSvg}
      inheritViewBox
      {...other}
      sx={[
        {
          "& path": { fill: "currentColor" },
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
    />
  );
}
